<template>
  <v-container>
    <base-material-card class="elevation-12" inline color="indigo darken-3" icon="mdi-cash">
      <template v-slot:after-heading>
        <span class="display-3 text--disabled">Abonos Aplicados</span>
      </template>
      <template>
        <v-container fluid class="mt-n4">
          <v-row>
            <v-layout row justify-end>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                <v-text-field label="Buscar Folio/Cliente" />
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                <v-menu
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDate"
                      append-icon="mdi-calendar-multiselect"
                      readonly
                      label="Fecha Inicial"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es"
                    color="indigo darken-3"
                    v-model="startDate"
                    :max="endDate"
                    @input="menuStartDate = false"
                    @change="LoadDebtsPayments"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                <v-menu
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDate"
                      append-icon="mdi-calendar-multiselect"
                      readonly
                      label="Fecha Final"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es"
                    color="indigo darken-3"
                    v-model="endDate"
                    :min="startDate"
                    @input="menuEndDate = false"
                    @change="LoadDebtsPayments"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-data-table
                class="elevation-1"
                dense
                :headers="headers"
                :loading="loading"
                :items="items"
                :hide-default-footer="loading"
                loading-text="Cargando datos. Por favor espere"
              >
                <template v-slot:item.active="{ item }">
                  <v-alert
                    dense
                    :color="item.active ? 'green' : 'error'"
                    outlined
                    dark
                    class="mb-0 py-2"
                  >
                    {{ item.active ? "Activa" : "Cancelada" }}
                  </v-alert>
                </template>
                <template v-slot:item.paymentDate="{ item }">
                  <span class="text-no-wrap">{{ transformDate(item.paymentDate) }}</span>
                </template>
                <template v-slot:item.creationDate="{ item }">
                  <span class="text-no-wrap">{{ transformDate(item.creationDate) }}</span>
                </template>
                <template v-slot:item.export="{ item }">
                  <v-layout justify-space-around>
                    <v-tooltip bottom max-width="400" color="green">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          size="21"
                          color="green"
                          @click="downloadXML(item)"
                          >mdi-xml</v-icon
                        >
                      </template>
                      <span>Descargar XML</span>
                    </v-tooltip>
                    <v-tooltip bottom max-width="400" color="green">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon v-bind="attrs" v-on="on" size="21" color="error" @click="downloadPDF(item)">
                          mdi-file-pdf
                        </v-icon>
                      </template>
                      <span>Descargar PDF</span>
                    </v-tooltip>
                  </v-layout>
                </template>
                <template v-slot:item.options="{ item }">
                  <v-layout justify-center>
                    <v-tooltip bottom max-width="400" color="red">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          size="21"
                          color="error"
                          @click="cancelPayment(item)"
                          >mdi-file-cancel</v-icon
                        >
                      </template>
                      <span>Cancelar</span>
                    </v-tooltip>
                  </v-layout>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </base-material-card>
    <generate-invoice
      :debtPaymentId="selectPDF"
      :title="titleDialog"
      @Close="dialogPDF = false"
    >
    </generate-invoice>
  </v-container>
</template>
<script>
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import Swal from 'sweetalert2';
export default {
  components: {
    GenerateInvoice: () => import("../../../Shared/exports/generatePayment.vue")
  },
  data() {
    return {
      loading: true,
      headers: [
        { text: "Estado", value: "active" },
        { text: "Cliente", value: "clientBilling" },
        { text: "Referencia", value: "reference" },
        { text: "Folio", value: "folio" },
        { text: "Folio Fiscal", value: "fiscalFolio" },
        { text: "Fecha de pago", value: "paymentDate"},
        { text: "Fecha de emisión", value: "creationDate" },
        { text: "Tipo Pago", value: "paymentType" },
        { text: "Archivos", value: "export" },
        { text: "Acciones", value: "options" }
      ],
      menuStartDate: false,
      menuEndDate: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment()
        .add(1, "day")
        .format("YYYY-MM-DD"),
      text: "",
      items: [],
      dialogPDF: false,
      titleDialog: "",
      selectPDF: 0,
      selectXML: 0,
      newFolio: null,
    };
  },
  created() {
    this.LoadDebtsPayments();
  },
  methods: {
    LoadDebtsPayments() {
      const filters = {
        startDate: moment(this.startDate).format(),
        endDate: moment(this.endDate).format(),
        text: ""
      };
      axios
        .post(`/api/Debts/Payments/Get`, filters, {
          headers: { bussinessId: this.$store.state._bussinessAccountId }
        })
        .then(result => result.data)
        .then(data => {
          this.items = data;
          this.loading = false;
        });
    },
    transformDate(date) {
      moment.locale('es');
      return moment(date).format("DD-MMMM-YYYY");
    },
    downloadPDF(item) {
      this.titleDialog = "PDF";
      this.selectPDF = item.id;
      this.dialogPDF = true;
    },
    async downloadXML(item) {
      this.dialogPDF = true;
      this.selectPDF = -1;
      this.titleDialog = "XML";
      const { data } = await axios.get(`/api/Debts/Payments/${item.id}`, {
        headers: { bussinessId: this.$store.state._bussinessAccountId }
      });
      const filename = `${data.serie}-${data.folio}`;
      setTimeout(() => {
        fileDownload(data.xmlData, `${filename}` + ".xml");
      }, 1000);
    },
    async cancelPayment(item) {
      try {
        const confirm = await Swal.fire({
          type: "question",
          title: "Cancelar complemento de pago",
          text: `¿Seguro desea cancelar este Complemento de Pago - ${item.folio}?`,
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar"
        });
        if(confirm.value) {
          const {value: id } = await Swal.fire({
            title: "Motivo de cancelación",
            input: "select",
            inputOptions: {
              '01': '01 - Comprobante emitido con errores con relación',
              '02': '02 - Comprobante emitido con errores sin relación',
              '03': '03 - No se llevó a cabo la operación',
              '04': '04 - Operación nominativa relacionada en la factura global'
            },
            inputPlaceholder: "Seleccione motivo de cancelación",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            confirmButtonText: "Aceptar",
            inputValidator: (value) => {
              return new Promise(async(resolve) => {
                if(value.length > 0 ) {
                  resolve();
                } else {
                  resolve('Seleccione un motivo de cancelación');
                }
              });
            }
          });
          if(id === undefined) {
            return;
          }
          if(id === "01") {
            const { value: folio } = await Swal.fire({
              title: "Nuevo folio fiscal",
              input: "text",
              inputLabel: "folio",
              inputPlaceholder: "Folio fiscal",
              showCancelButton: false,
              allowOutsideClick: false,
              inputValidator: (value) => {
                if(!value) {
                  return "Folio fiscal requerido"
                }
              }
            });
            this.newFolio = folio
          }
          const { data } = await axios.delete(`/api/Debts/Payments/${item.id}`, {
            headers: { bussinessId: this.$store.state._bussinessAccountId },
            data: { motivoCancelacion: id, uuidSustitucion: this.newFolio}
          });
          if(data){
            Swal.fire({
              title: "Exito",
              text: "Complemento de Pago Cancelado con Exito",
              type: "success"
            });
            this.LoadDebtsPayments();
          }
        }
      } catch (err) {
        const message = err.response.data.cancelaciones.cancelacion.mensaje;
        Swal.fire({
          title: "No se ha podido cancelar",
          text: `${message}`,
          type: "error"
        });
      }
    }
  }
};
</script>
